export const sharedKitsTableColumns = [
  { id: 'kitNickname', label: 'Kit Nickname' },
  { id: 'totalQnty', label: 'Total Qty' },
  { id: 'viewDetailsButton', label: '' },
  { id: 'orderButton', label: '' },
  { id: 'deleteButton', label: '' },
];

export const RESTRICTION_PERIOD = {
  none: 'NONE',
  monthly: 'MONTHLY',
  annual: 'ANNUAL',
};

export const APPROVAL_MODE = {
  none: 'NONE',
  always: 'ALWAYS',
  overLimit: 'OVER_LIMIT',
};

export const emptySharedKitsMessage =
  'There are currently no shared marketing kits available to you';

export const deleteSharedKitMessage =
  'Deleting Will Remove This Kit From Your Shared Marketing Kits And It Will No Longer Be Available To Order.';

export const SHARED_KITS_PATH = '/kits/shared';

export const ORDER_BUTTON_TITLE = 'Order';

export const attendeeCountLabel = 'Please enter the number of attendees:';

export const invalidAttendeeCountMessage =
  'Please enter a whole number greater than 0';

export const SHARED_KIT_MODAL_TITLE = 'Add to Shared Marketing Kits';

export const kitNicknameLabel = 'Marketing Kit Nickname:';

export const subgroupsLabel = (marketingAccessGroup) =>
  `${marketingAccessGroup}:  Please select one or more groups that should have access to this kit.`;

export const maxQuantityLabel =
  'Maximum Quantity of kits that may be ordered per period';

export const restrictionPeriodLabel = 'Select one restriction period:';

export const restrictionPeriods = [
  { value: RESTRICTION_PERIOD.monthly, label: 'Monthly Restriction Period' },
  { value: RESTRICTION_PERIOD.annual, label: 'Annual Restriction Period' },
];

export const optionalSectionLabel = 'Optional:';

export const approveAllOrdersLabel = 'I want to approve all orders';

export const approveAllOrdersHint =
  'If unchecked, you will only be required to approve orders over the maximum quantity.';

export const attendeeCountRequiredLabel = 'Attendee count is required';

export const attendeeCountRequiredHint =
  'If checked, the user must provide the attendee count and the quantities added to their cart will support that count.';

export const ADD_TO_SHARED_KITS_BUTTON = '+ Add to Shared Marketing Kits';

export const EDIT_SHARED_KIT_BUTTON = 'Edit Nickname and Group Association';

export const orderKitWithoutProductsMessage = (count) =>
  count === 1
    ? 'Do You Want To Order The Kit Without This Product?'
    : 'Do You Want To Order The Kit Without These Products?';

export const SKIPPED_PRODUCT_HEADER = 'This Product Was Not Added.';

export const SKIPPED_PRODUCTS_HEADER = 'These Products Were Not Added.';

export const skippedProductsMessage = (count) =>
  count === 1
    ? 'The Product Below Is Out Of Stock Or Unavailable And Was Not Added To Your Cart.'
    : 'The Products Below Are Out Of Stock Or Unavailable And Were Not Added To Your Cart.';
